import React from 'react';
import { withRouter } from 'react-router-dom';
import TitleBar from '../common/title_bar'
import Nivel1Form from './RegrasForms/Nivel1'
import Nivel2Form from './RegrasForms/Nivel2'
import Nivel2Tabs from './RegrasForms/Nivel2Tabs'
import { Route } from 'react-router-dom'
import CriarFluxo from './RegrasForms/CriarFluxo';


class RuleMainForm extends React.Component {
  render() {
    console.log("props",this.props)
    return (
      <div className="inner-container">
        <div className="outer-space">
          <TitleBar 
            title={this.props.linkData && this.props.linkData.TitleBartitle} 
            logo="contacorrente" 
            prevPageLink={"/conta_corrente"}
            prevPageName={this.props.linkData.prevPageName}
          />
        </div>
        <Route path={ `${this.props.match.path}/nivel-1` } component={ Nivel1Form } />
        <Route path={ `${this.props.match.path}/gestaoRegras` } component={ Nivel2Form } />
         <Route path={ `${this.props.match.path}/criarFluxo` } component={ CriarFluxo } />
      </div>
    )
  }
}

export default withRouter(RuleMainForm);
